import {createApi,fetchBaseQuery} from  '@reduxjs/toolkit/query/react'

const  cryptoNewsApiHeaders ={
    'x-bingapis-sdk': 'true',
    'x-rapidapi-host': 'bing-news-search1.p.rapidapi.com',
    'x-rapidapi-key': 'cdc7b3c198msh452eee1f1cfc09cp1e4a5ajsn02af502771b3'
  }

const basedUrl='https://bing-news-search1.p.rapidapi.com';

const createRequest=(url)=>({url, headers :cryptoNewsApiHeaders})

export const cryptoNewsApi = createApi({
  reducerPath: 'cryptoNewsApi',
  baseQuery: fetchBaseQuery({ baseUrl:basedUrl }),
  endpoints: (builder) => ({
    getCryptoNews: builder.query({
      query: ({ newsCategory, count }) => createRequest(`/news/search?q=${newsCategory}&safeSearch=Off&textFormat=Raw&freshness=Day&count=${count}`),
    }),
  }),
});

export const { useGetCryptoNewsQuery } = cryptoNewsApi;